import { render } from "./AdditionCreatePage.vue?vue&type=template&id=5bc7a979&scoped=true"
import script from "./AdditionCreatePage.vue?vue&type=script&lang=js"
export * from "./AdditionCreatePage.vue?vue&type=script&lang=js"

import "./AdditionCreatePage.vue?vue&type=style&index=0&id=5bc7a979&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc7a979"]])

export default __exports__